import { deserialize, serialize } from "serializr";

import _axiosInstance from "../../interceptor/_axiosInstance";

import { FilterLoginActivity, LoginActivitySummaryModel } from "../../models/ReportsModel/loginActivity.model";

import { LOGIN_ACTIVITY_SUMMARY,DOWNLOAD_LOGIN_ACTIVITY_SUMMARY } from "../../routes/routeConstants/apiRoutes";
import { defaultFilterReports } from "../../shared/utils/filter";


export default class LoginActivityReportService {

  static fetchLoginActivityReport(
    data: FilterLoginActivity,
    onSuccess: (data: LoginActivitySummaryModel[]) => void,
    onError: Function,
    onFinal: () => void
  ) {
    const payload = serialize(FilterLoginActivity, { ...defaultFilterReports, ...data })
    delete payload.type;
    return _axiosInstance.get(LOGIN_ACTIVITY_SUMMARY, { params: payload })
      .then(response => {
        const data = deserialize(LoginActivitySummaryModel, response?.["data"]) as LoginActivitySummaryModel[];
        onSuccess(data);
      })
      .catch(error => {
        onError(error)
      })
      .finally(onFinal)
  }

  static downloadLoginActivityReport(
    data: FilterLoginActivity,
    onSuccess: (value: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    const payload = serialize(FilterLoginActivity, { ...defaultFilterReports, ...data })
    delete payload.type;
    return _axiosInstance.get(DOWNLOAD_LOGIN_ACTIVITY_SUMMARY, { params: payload })
      .then((response) => new Blob([response.data]))
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `Report.csv`,
        );
        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode?.removeChild(link);

        onSuccess("Download");
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }


}   